import React from "react";

import { Modal } from "shared/components";

import { copy } from "shared/assets";

import { EditInfoBlockItemBaseProps, getInfoBlockItemIcon } from "shared/utils";

interface EditInfoBlockItemModalProps extends EditInfoBlockItemBaseProps {
  itemReadbleName: string;
  Component: React.FC<any>;
  componentProps: any;
}

export const EditInfoBlockItemModal: React.FC<EditInfoBlockItemModalProps> = ({
  type,
  handleClose,
  itemReadbleName,
  Component,
  componentProps,
}) => {
  return (
    <Modal
      handleClose={handleClose}
      title={copy.editInfoBlockItem.title.replace("%s", itemReadbleName)}
      data-testid={`edit_${type}_modal`}
      icon={getInfoBlockItemIcon(type)}
    >
      {<Component {...componentProps} />}
    </Modal>
  );
};
